(function ($) {

	$.fn.inlineStyle = function (prop) {
		var styles = this.attr("style"),
			value;
		styles && styles.split(";").forEach(function (e) {
			var style = e.split(":");
			if ($.trim(style[0]) === prop) {
				value = style[1];
			}
		});
		return value;
	};

	$.fn.onAny = function (cb) {
		for (var k in this[0])
			if (k.search('on') === 0)
				this.on(k.slice(2), function (e) {
					// Probably there's a better way to call a callback function with right context, $.proxy() ?
					cb.apply(this, [e]);
				});
		return this;
	};

}(jQuery));
